export const message = (message = '', typeMessage = '') => (`
  <span id="signature-digital__forgot-password-message--${typeMessage}" class="">
    ${message}
  </span>
`);

const forgotPassword = () => (`
  <button id="signature-digital__forgot-password">Esqueceu sua assinatura eletrônica?<div id="signature-digital__loader"></div></button>
  <div id="signature-digital__forgot-password-message">
    ${message()}
  </div>
`);

export default forgotPassword;